<template>
  <div>
    <ArticleShow ref='as'/>
    <LabelDialog ref="ll" @success="labelSuccess" />
    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>文章列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="a-t">
      <el-button @click="handleAdd" type="primary">
        新增
      </el-button>
    </div>
    <LoadingNoDialog :loading="loading">
      <el-table
        class="clear-fix"
        border
        :empty-text="emptyText"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="标题" prop="title"> </el-table-column>
        <el-table-column label="描述" prop="des"> </el-table-column>
        <el-table-column label="内容" width="230">
          <template slot-scope="scope">
            <div v-html="scope.row.content" class="content"></div>
          </template>
        </el-table-column>

        <el-table-column label="封面">
          <template slot-scope="scope">
            <img :src="scope.row.img" style="max-height:80px" />
          </template>
        </el-table-column>
        <el-table-column prop="labelName" label="标签"> </el-table-column>

        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>

        <el-table-column fixed="right" label="操作" width="230px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="(e) => show(scope.row)"
              >查看</el-button>
            <el-button type="info" size="small" @click="(e) => edit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="(e) => deleteRow(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </LoadingNoDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import TagImgUpload from "./component/TagImgUpload.vue";
import LabelDialog from "./component/LabelDialog.vue";
import Img from "../../components/Img.vue";
import ArticleShow from './ArticleShow.vue'
export default {
  name: "Role",
  data() {
    return {
      emptyText: "暂无数据",
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      tagImgDialog: false,
      tagInfo: {
        objectKey: "",
        imgUrl: "",
      },
      subTagLoading: false,
      isAdd: true,
    };
  },
  components: {
    ElButton,
    LoadingNoDialog,
    TagImgUpload,
    LabelDialog,
    Img,
    ArticleShow
  },
  mounted() {
    this.getList();
  },
  methods: {
    show(row){
      this.$refs.as.setRow(row)
    },
    handleAdd() {
      this.$router.push("/article-add");
    },
    labelSuccess() {
      this.getList();
    },

    handleAddTag() {
      this.$refs.oa.setMyRow(this.tableData);
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    edit(row) {
      /**
       */
     // this.$refs.ll.setValue(row);
     this.$router.push('/article-add?id='+row.id)
    },
    deleteRow(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: "删除中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let r = await axios.delete("/admin/delete-article", {
          params: { id: row.id },
        });
        loading.close();
        if (r.code == 0) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
        } else {
          this.$message.warning("删除失败");
        }
        this.getList();
      });
    },

    async getList() {
      this.loading = true;

      let r = await axios.get("/admin/articl-list", {
        params: {
          page: this.page,
          size: this.size,
        },
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.tableData = r.data.rows.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );

      this.total = r.data.count;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.t-u-w {
  display: flex;
  justify-content: center;
}
.a-t {
  margin-bottom: 10px;
}
.content {
  max-height: 200px;
  overflow: scroll;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/Article.vue